module.exports = new __parcel__URL__("nature_bg.34b10981.jpg").toString();